<template>
    <div class="tgh-map tgh-page tgh-home">
        <h4>KeTengah . DiTengah . DariTengah</h4>
        <div class="mapouter">
            <div class="gmap_canvas">
                <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=Tengah%20By%20Stbd&t=&z=15&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
            </div>
        </div>
        <div class="tgh-form-subs px-sm-0 px-3">
            <input type="text" v-model="email"><button type="button" @click="subscribe()">Subscribe</button>
        </div>
        <div class="row no-gutters tgh-keep-in-touch">
            <div class="col-12">
                <p class="text-center">For further information please contact us <br>
                WhatsApp: <a target="_blank" href="https://wa.me/+6281295639046">+62812 9563 9046</a> <br>
                Phone: <a target="_blank" href="tel:+62215253191">+6221 525 3191</a> <br>
                Email: <a target="_blank" href="mailto:info@tengahtengah.com">info@tengahtengah.com</a> / <a target="_blank" href="mailto:tengahtengah@gmail.com">tengahtengah@gmail.com</a><br>
                <!-- Direction: <a href="https://maps.google.com/maps?q=Tengah%20By%20Stbd" target="_blank">Hello we are here!</a> -->
                </p>
            </div>
        </div>
        <transition name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated bounceOut">
        <div class="tgh-thanks" v-show="subscribed">
            <h1>Thank You</h1>
            <h6>You have been successfully subscribed</h6>
        </div>
        </transition>
    </div>
</template>
<script>
import {apiUrl} from '../config'
import axios from 'axios'
import TitlePage from '@/components/TitlePage.vue'
export default {
    name : 'Maps',
    components: {
        TitlePage
    },
    data() {
        return {
            email : null,
            subscribed : false
        }
    },
    methods : {
        subscribe(){
            let vm = this
            let url = apiUrl+'/home/subscribe'
            let data = {email:this.email}
            axios.post(
                url,
                data
            )
            .then(response => {
                console.log(response)
                vm.subscribed = true
                setTimeout(function(){vm.subscribed=false},3000)
                vm.email = null
            })
            .catch(e => {
                console.log('Internal server error')
            })
        }
    }
}
</script>